import { Grid, FormControlLabel, Radio, Checkbox } from '@material-ui/core';
import React, { Fragment } from 'react';
import { useState } from 'react';

const Free = ({ question, setAnswer }) => {
    /**
     * STATE
     */
    const [value, setValue] = useState('');
    console.log(question);

    /**
     * CONTROLS
     */
    const change = (e) => {
        setValue(e.target.value);
        setAnswer(question.id, [e.target.value]);
    };

    return (
        <Fragment>
            {question.answers.map((choice, index) => (
                <Grid key={index} item xs={12} sm={12}>
                    <FormControlLabel
                        onChange={change}
                        control={<Radio />}
                        label={choice.text}
                        labelPlacement='end'
                        value={choice.text}
                        checked={value === choice.text}
                    />
                </Grid>
            ))}
        </Fragment>
    );
};

export default Free;
